// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"6ab0ca4d","787":"4bff918f"}[chunkId] + ".chunk.js";
};